import { resolveSaveOverwriteTarget } from '../calc/resolveSaveOverwriteTarget';

export function resolveSnapshotSaveOverwriteTarget({
  loadVersionId,
  snapshotName,
  savedVersions,
}) {
  return resolveSaveOverwriteTarget({
    loadId: loadVersionId,
    modelName: snapshotName,
    savedModels: (savedVersions || []).map((version) => ({
      id: version.id,
      name: version.name,
    })),
  });
}
